import React from 'react';
import { Link } from 'gatsby';

import css from './Card.module.scss';

const Card = ({
	src,
	alt,
	heading,
	description,
	link,
	featured,
	featuredText,
}) => {
	return (
		<div className={css.card}>
			{featured && <div className={css.featured}>{featuredText}</div>}
			<div className={css.content}>
				<div className={css.heading}>
					<img src={`/images/components/feature-cards/${src}`} alt={alt} />
					<h3>{heading}</h3>
				</div>
				<p>{description}</p>
			</div>
			<Link to={link} className="linkArrow">
				Learn More
			</Link>
		</div>
	);
};

export default Card;
